import {Link, LinkProps} from 'react-router';
import clsx from 'clsx';
import React, {ReactNode} from 'react';
import {getBootstrapData} from '@ui/bootstrap-data/bootstrap-data-store';
import {localizeTo} from '@app/i18n/localize-link';

export interface BaseMediaLinkProps extends Omit<LinkProps, 'to' | 'title'> {
  link: string;
  className?: string;
  children?: ReactNode;
  color?: 'primary' | 'inherit';
  displayContents?: boolean;
}
export function BaseMediaLink({
  link,
  className,
  children,
  color = 'inherit',
  displayContents,
  ...linkProps
}: BaseMediaLinkProps) {
  const baseClassName = displayContents
    ? 'contents'
    : clsx(
        color === 'primary'
          ? 'text-primary hover:text-primary-dark'
          : 'text-inherit',
        'hover:underline outline-none focus-visible:underline overflow-x-hidden overflow-ellipsis transition-colors',
      );
  return (
    <Link {...linkProps} className={clsx(baseClassName, className)} to={link}>
      {children}
    </Link>
  );
}

/**
 * B19 (Day 29) — locale-aware internal links. Link helpers build TR-segment
 * paths ("/tr/film/...", "/tr/kisi/...", "/tr/ulkeler/..."). localizeTo()
 * rewrites them to the active locale ("/en/movie/...", "/ar/musalsal/...") so
 * non-TR users stay in their locale. TR is a no-op (zero regression).
 */
export function getBaseMediaLink(
  link: string,
  {absolute}: {absolute?: boolean} = {},
): string {
  link = localizeTo(link);
  if (absolute) {
    link = `${getBootstrapData().settings.base_url}${link}`;
  }
  return link;
}
